import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const loginSchema = (t: TFunction) => {
    return Yup.object().shape({
        username: Yup.string()
            .email(t('loginPage.invalidEmail'))
            .required(t('loginPage.emailIsRequired')),
        password: Yup.string().required(t('loginPage.passwordIsRequired')),
    });
};

export const testSchema = (t: TFunction) => {
    return Yup.object().shape({
        username: Yup.string()
            .email(t('loginPage.invalidEmail'))
            .required(t('loginPage.emailIsRequired')),
        password: Yup.string().required(t('loginPage.passwordIsRequired')),
        datePicker: Yup.string().required(t('loginPage.passwordIsRequired')),
        selector: Yup.string().required(t('loginPage.passwordIsRequired')),
        textArea: Yup.string().required(t('loginPage.passwordIsRequired')),
    });
};

export const forgotPasswordSchema = (t: TFunction) => {
    return Yup.object().shape({
        email: Yup.string()
            .email(t('loginPage.invalidEmail'))
            .required(t('loginPage.emailIsRequired')),
    });
};

export const ResetPasswordSchema = (t: TFunction) => {
    return Yup.object().shape({
        password: Yup.string().required(
            t('resetPasswordPage.passwordIsRequired')
        ),
        passwordReEntry: Yup.string()
            .required(t('resetPasswordPage.passwordReEntryIsRequired'))
            .oneOf(
                [Yup.ref('password')],
                t('resetPasswordPage.passwordsMustMatch')
            ),
    });
};
